
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/core/services/ApiService";
import { translate, statusColor } from "@/core/services/HelpersFun";
import PaymentRequestDetails from "@/views/pages/Admin/cooperationInSale/component/PaymentRequestDetails.vue";

interface Filter {
  status: string | null;
  page: string | number;
}

export default defineComponent({
  name: "kt-ManagementPaymentRequestList-table",
  components: {
    PaymentRequestDetails,
  },
  props: {
    widgetClasses: String,
  },
  setup() {
    const loading = ref(true);
    const list = ref();
    const selectedItem = ref();
    const page = ref(1);
    const filter = ref<Filter>({
      status: null,
      page: page.value,
    });
    const changeServerValue = ref({});
    const resetFilter = () => {
      filter.value.status = null;
      filter.value.page = 1;
      getItems();
    };

    const getItems = () => {
      loading.value = true;
      ApiService.query("/admin/request-payment", { params: filter.value })
        .then(({ data }) => {
          loading.value = false;
          list.value = data.data.requests.data;
          pagination.value = data.data.requests.pagination;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    const pagination = ref();

    const handleCurrentChange = (val: number) => {
      filter.value.page = val;
      getItems();
    };

    onMounted(() => {
      getItems();
    });

    return {
      loading,
      list,
      pagination,
      handleCurrentChange,
      page,
      getItems,
      translate,
      statusColor,
      filter,
      resetFilter,
      selectedItem,
      changeServerValue,
    };
  },
});
